'use strict';

var React = require('react');

var SvgStoreFilledMinor = function SvgStoreFilledMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.714 3.176a.5.5 0 0 0-.38-.176h-6.668a.5.5 0 0 0-.38.176l-2.31 2.713a2 2 0 0 0-.476 1.296v.815a1.5 1.5 0 0 0 1.5 1.5 1.75 1.75 0 0 0 1.75-1.75.75.75 0 0 1 1.5 0 1.75 1.75 0 1 0 3.5 0 .75.75 0 0 1 1.5 0c0 .966.784 1.75 1.75 1.75a1.5 1.5 0 0 0 1.5-1.5v-.815a2 2 0 0 0-.477-1.296l-2.309-2.713Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.125 11h-.125a3.243 3.243 0 0 1-2.5-1.173 3.243 3.243 0 0 1-2.5 1.173 3.243 3.243 0 0 1-2.5-1.173 3.243 3.243 0 0 1-2.5 1.173h-.125v4.75c0 .621.504 1.125 1.125 1.125h8c.621 0 1.125-.504 1.125-1.125v-4.75Zm-2.125 2.25a1 1 0 0 0-1-1h-.5a1 1 0 0 0-1 1v2.75h2.5v-2.75Z"
  }));
};
SvgStoreFilledMinor.displayName = "StoreFilledMinor";

exports.SvgStoreFilledMinor = SvgStoreFilledMinor;
